import { Canvas } from "@react-three/fiber"
import { Suspense } from "react"
import { BRAND_HEX } from "@/lib/colors"
import { Robot } from "./Robot"

export function RobotScene() {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-5 md:z-20"
      aria-hidden="true"
    >
      <Canvas
        camera={{ position: [0, 0, 4.2], fov: 38 }}
        dpr={[1, 1.25]}
        gl={{
          alpha: true,
          antialias: true,
          powerPreference: "high-performance",
        }}
        style={{ pointerEvents: "none" }}
      >
        <ambientLight intensity={0.45} />
        <directionalLight position={[3, 4, 5]} intensity={1.5} />
        <directionalLight
          position={[-4, 2, -3]}
          intensity={0.7}
          color={BRAND_HEX}
        />
        <directionalLight
          position={[0, -3, 2]}
          intensity={0.35}
          color="#ff6a3d"
        />
        <Suspense fallback={null}>
          <Robot />
        </Suspense>
      </Canvas>
    </div>
  )
}
